import { CURRENT_ORGANIZATION } from '@/consts';

import { ErrorDiagnostics, normalizeError } from './reportText';

export interface BuildErrorDiagnosticsParams {
    fileIds: string[];
    linkId?: string;
    user?: string;
    userId?: string;
    organizationId?: string;
    statusCode?: number;
    message?: string;
    error?: unknown;
}

/** Builds {@link ErrorDiagnostics} from runtime context at a file-load failure site. */
export const buildErrorDiagnostics = (params: BuildErrorDiagnosticsParams): ErrorDiagnostics => {
    const normalized = params.error
        ? normalizeError(params.error)
        : {
            statusCode: params.statusCode,
            message: params.message ?? '',
        };

    return {
        referenceId: `SPX-ERR-${Math.random().toString(16).slice(2, 8).toUpperCase()}`,
        time: new Date().toISOString(),
        statusCode: normalized.statusCode ?? params.statusCode,
        message: normalized.message || params.message || '',
        fileIds: params.fileIds,
        linkId: params.linkId,
        user: params.user ?? '',
        userId: params.userId ?? '',
        organizationId: params.organizationId
            ?? localStorage.getItem(CURRENT_ORGANIZATION)
            ?? undefined,
        environment: import.meta.env.VITE_STAGE ?? 'unknown',
        page: window.location.href,
        browser: navigator.userAgent,
    };
};
